import { render, staticRenderFns } from "./DocumentCreateUpdate.vue?vue&type=template&id=3261f170&"
import script from "./DocumentCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./DocumentCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports